export class Resources {
    id: number;
    type: string;
    category: string;
    title: string;
    points: number;
    is_free: number;
    duration: number;
    file_type: string;
    file_type_title: string;
    link_url: string;
    image_url: string;
    cover_color: string;
}
